//获取请求URL中某些参数的值
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

export { //很关键
  getUrlKey
}




// WEBPACK FOOTER //
// ./src/components/Common/utils.js